module.exports = __webpack_public_path__ + "img/ipad-gestures-3.b978963.jpg";